import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=28c7f8ce&scoped=true&"
import script from "./Media.ts?vue&type=script&lang=ts&"
export * from "./Media.ts?vue&type=script&lang=ts&"
import style0 from "./Media.scss?vue&type=style&index=0&id=28c7f8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7f8ce",
  null
  
)

export default component.exports